import { render, staticRenderFns } from "./fbxUpload.vue?vue&type=template&id=3d252b68&"
import script from "./fbxUpload.vue?vue&type=script&lang=js&"
export * from "./fbxUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports